import client from '../client';
import * as countryQueries from "../queries/country";
import * as countryMutations from "../mutations/country";


export function getCountries(success, error, force = false) {
    let fetchPolicy = 'cache-first';

    if (force === true) {
        fetchPolicy = 'network-only';
    }

    client.query({
        fetchPolicy: fetchPolicy,
        query: countryQueries.all,
    })
    .then(success)
    .catch(error);
}

export function edit(success, error, id, data) {
    client.mutate({
        variables: { id: id, country: data },
        mutation: countryMutations.edit,
    })
    .then(success)
    .catch(error);
}

export function add(success, error, data) {
    client.mutate({
        variables: { country: data },
        mutation: countryMutations.add,
    })
        .then(success)
        .catch(error);
}


// WEBPACK FOOTER //
// ./src/graphql/actions/country.js